// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610200705/js/" + chunkId + "." + {"44":"1d6bb6a9","225":"a822b878","481":"c7f6f7b6","486":"2d683c4a","770":"32325f5f"}[chunkId] + ".0.2881363062855328.chunk.js";
};